import { GREEN, GREEN_T, GREEN_LINE } from 'common/styles/listUI';
import { BRAND_IDS } from 'home/DomainName/DomainConstants';

const PETASENSE_TONE = { ink: GREEN, tint: GREEN_T, line: GREEN_LINE };

/**
 * The brand's own colours for what marks a choice rather than a kind of thing:
 * an active filter, the selected option, the latest release, a search match,
 * a focus ring. A partner's domain gets its own (NTN blue); Petasense's, and a
 * theme that has not loaded yet, our green. Colours that say what something
 * is (a feature or a published release note) stay as they are on every domain.
 */
export const brandTone = (theme) => {
  if (!theme || !theme.brandId || theme.brandId === BRAND_IDS.PETASENSE) return PETASENSE_TONE;
  return {
    ink: theme.badgeColor || theme.primaryColor || GREEN,
    tint: theme.badgeBackground || GREEN_T,
    line: theme.costSavedHighlightBorder || GREEN_LINE
  };
};

/** The brand's tone parts, for a styled component's interpolation. */
export const brandInk = props => brandTone(props.theme).ink;
export const brandTint = props => brandTone(props.theme).tint;
export const brandLine = props => brandTone(props.theme).line;
